import { Component, Input } from "@angular/core";

@Component({
    selector: "app-extension-details",
    templateUrl: "./extension-details.component.html",
    styleUrls: ["./extension-details.component.scss"],
    standalone: false
})
export class ExtensionDetailsComponent {
  @Input() isInstalled = false;
  @Input() version: number;
  @Input() planId: string;
  @Input() isChromeBrowser = false;
}
